import { render } from "./NavButton.vue?vue&type=template&id=0aadea5f"
import script from "./NavButton.js?vue&type=script&lang=js"
export * from "./NavButton.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__